import React from "react";
import { Accordion, Button, Card, Col, Row } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import "./faq.css";

const QandA = ({eventKey, question}) => {
  return (
    <Card>
      <Card.Header>
        <Row>
          <Col>
            <strong>{question.question}</strong>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <ReactMarkdown className="faq" source={question.answer} />
          </Col>
        </Row>
        {question.details && question.details.trim().length > 0 ? (
          <Accordion>
            <Row className="justify-content-center">
              <Col xs="auto">
                <Accordion.Toggle
                  as={Button}
                  eventKey={eventKey}
                  size="sm"
                  variant="outline-info"
                >
                  More Details
                </Accordion.Toggle>
              </Col>
            </Row>
            <Accordion.Collapse eventKey={eventKey}>
              <Card.Body>
                <ReactMarkdown source={question.details} />
              </Card.Body>
            </Accordion.Collapse>
          </Accordion>
        ) : null}
      </Card.Body>
    </Card>
  );
}

export default QandA; 